<form class="form vc-admin-password-form" [formGroup]="form" (ngSubmit)="execute()" novalidate>
  <div class="grid">
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="password">{{ 'COMMON.PASSWORD_NEW' | translate }} *</label>

        <p-password
          inputId="password"
          [toggleMask]="true"
          [feedback]="false"
          formControlName="password"
          fluid
        />

        <small
          id="user-password-help"
          class="p-error"
          *ngIf="(submitted || form.controls['password'].touched) && errors.password"
        >
          {{ errors.password }}
        </small>
      </div>
    </div>

    <div class="col-12 md:col-6">
      <div class="field">
        <label for="password_confirmation">{{ 'COMMON.PASSWORD_REPEAT' | translate }} *</label>

        <p-password
          inputId="password_confirmation"
          [toggleMask]="true"
          [feedback]="false"
          formControlName="password_confirmation"
          fluid
        />

        <small
          id="user-password-confirm-help"
          class="p-error"
          *ngIf="
            (submitted || form.controls['password_confirmation'].touched) &&
            errors.password_confirmation
          "
        >
          {{ errors.password_confirmation }}
        </small>
      </div>
    </div>

    <div class="col-12">
      <app-admin-password-rules [password]="form.controls['password'].value || ''"></app-admin-password-rules>
    </div>

    <div class="col-12">
      <app-admin-form-actions
        primaryLabelKey="COMMON.SAVE"
        [submitting]="submitting"
      ></app-admin-form-actions>
    </div>
  </div>
</form>
